// extracted by mini-css-extract-plugin
export default {"root":"SellNudge-root","inner":"SellNudge-inner","title":"SellNudge-title","body":"SellNudge-body","actions":"SellNudge-actions"};